import { ensureArray } from 'utils/array';
import { createExternalStore } from 'providers/createStore';

let onlineUsers = new Set<string>();

export const { useIsUserOnline, useOnlineUsers, ...onlineActions } = createExternalStore({
  actions: {
    add(id: string | string[]) {
      onlineUsers = new Set(onlineUsers);
      ensureArray(id).forEach((i) => onlineUsers.add(i));
    },

    remove(id: string) {
      onlineUsers = new Set(onlineUsers);
      onlineUsers.delete(id);
    },

    overwrite(ids: string[]) {
      onlineUsers = new Set(ids);
    },
  },

  selectors: {
    isUserOnline(id: string) {
      return onlineUsers.has(id);
    },

    onlineUsers() {
      return onlineUsers;
    },
  },
});
